export const Constants = {
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    authBase: "auth",
    templatesBase: "templates",
    customerBase: "customer",
    messageLogsBase: "message-logs",
    brandBase: "brand",
    campaignBase: "campaign",
    messagesBase: "messages",
}
